<template>
    <div class="leftBox">
        <div class="item_cate">
            <div class="cate_title">个人中心</div>
            <ul>
                <li :class="{active:this.$store.state.userIndex==1001}">
                    <router-link to="/User">基本信息</router-link>
                </li>
            </ul>
        </div>
        <div class="item_cate">
            <div class="cate_title">账户信息</div>
            <ul>
                <li :class="{active:this.$store.state.userIndex==2001}">
                    <router-link to="/User/Address">地址管理</router-link>
                </li>
                <li :class="{active:this.$store.state.userIndex==2002}">
                    <router-link to="/User/Collect">我的收藏</router-link>
                </li>
            </ul>
        </div>
        <div class="item_cate">
            <div class="cate_title">交易管理</div>
            <ul>
                <li :class="{active:this.$store.state.userIndex==3001}">
                    <router-link to="/User/Order">订单管理</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    name: "left",
    data() {
        return {

        }
    },
    mounted() {
        if(!this.$noLoginToLogin()){
            //
        }
    },
    watch: {},
    methods: {}
}
</script>

<style scoped lang="less">

ul, li {
    margin: 0;
    padding: 0;
    outline: none;
    list-style: none;
}

.leftBox {
    width: 120px;
    height: 245px;
    margin-right: 30px;
    padding: 50px 50px 30px;
    background-color: white;
    display: flex;
    flex-direction: column;

    .item_cate {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;

        .cate_title {
            font-size: 18px;
            color: #333;
            cursor: pointer;
            margin-bottom: 5px;
        }

        .on {
            color: #1f2d5c;
            font-weight: bold;
        }

        ul {
            display: flex;
            flex-direction: column;
            color: #999;
            font-size: 14px;

            li {
                margin: 6px 0px;
                cursor: pointer;
                padding-left: 15px;

                a {
                    color: #999;
                    display: block;
                    border-bottom: 1px dashed transparent;
                    width: fit-content;
                }
            }

            .active {

                a {
                    color: #1f2d5c !important;
                    font-weight: bold;
                    border-bottom: 1px dashed #1f2d5c;
                    width: fit-content;
                }
            }
        }
    }

    .on {
        font-weight: bold;
    }
}
</style>
